import { Injectable } from "@angular/core";
import { BackendService } from "./backend.service";
import { Metric, EmployeeMetricData, DisplayMetric } from "../models/metric.model";
import { forkJoin, Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { UserBio } from "../models/UserBio";
import { ChatMessageResponse } from "../models/ChatMessageResponse.model";
import { ChatMessage } from "../models/ChatMessage.model";

@Injectable({
  providedIn: "root",
})
export class ChatService {
  constructor(private backendService: BackendService) {}

  sendMessage(message: ChatMessage): Observable<ChatMessageResponse> {
    return this.backendService.backendRequest("POST", "/chat/message", message);
  }

  submitFeedback(message: ChatMessage, helpful: boolean): Observable<any> {
    const feedback = {
      messageId: message.messageId,
      sessionId: message.sessionId,
      helpful: helpful,
      timestamp: new Date().toISOString(),
    };
    return this.backendService.backendRequest(
      "PUT",
      `/chat/message/${feedback.messageId}/feedback`,
      feedback
    );
  }
}
